// hooks/useMessageSelection.js
//
// Desktop-only selection hook.
// Mobile touch (long-press + swipe + scroll) is now fully handled
// by useSwipeReply via its onLongPress / onTap callbacks.
//
// This hook handles:
//   - Desktop right-click  → onContextMenu in MessageList (toggleMessageSelect)
//   - Desktop long-press   → mousedown timer (350 ms)
//   - Desktop mouseup/leave → cancel the timer

export function useMessageSelection({
  selectedMessages,
  setSelectedMessages,
  selectionMode,
  setSelectionMode,
  longPressTimer,
  longPressTriggered,
}) {
  const toggleMessageSelect = (msgId) => {
    setSelectedMessages((prev) => {
      if (prev.includes(msgId)) {
        const next = prev.filter((id) => id !== msgId);
        if (next.length === 0) setSelectionMode(false);
        return next;
      }
      return [...prev, msgId];
    });
    setSelectionMode(true);
  };

  const clearSelection = () => {
    setSelectedMessages([]);
    setSelectionMode(false);
  };

  /* ── Desktop mouse long-press ── */
  const handleMouseDown = (msgId) => {
    longPressTriggered.current = false;
    longPressTimer.current = setTimeout(() => {
      longPressTriggered.current = true;
      toggleMessageSelect(msgId);
    }, 350);
  };

  const handleMouseUp = () => {
    clearTimeout(longPressTimer.current);
  };

  const handleMouseLeave = () => {
    clearTimeout(longPressTimer.current);
  };

  return {
    toggleMessageSelect,
    clearSelection,
    handleMouseDown,
    handleMouseUp,
    handleMouseLeave,
  };
}